export const generateTimestamp = () => {
  const date = new Date()
  const [readableDate, _time] = date.toISOString().split('T')
  const [hour, minute, _second] = date.toLocaleTimeString('UTC').split(':')

  return `${readableDate}-${hour}-${minute}`
}
